var _rect, _path, _path2, _mask, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.10626,
    y: 4.87969,
    width: 17.748,
    height: 13.2366,
    rx: 1.88231,
    fill: "#888888",
    stroke: "#888888",
    strokeWidth: 1.41173
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 7.69218C0.400391 6.26277 1.55916 5.104 2.98857 5.104H16.972C18.4014 5.104 19.5602 6.26277 19.5602 7.69218V8.8449C19.5602 11.2733 17.5915 13.242 15.1631 13.242H4.79746C2.36902 13.242 0.400391 11.2733 0.400391 8.8449V7.69218Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.400391 5.04122C0.400391 4.56217 0.788735 4.17383 1.26778 4.17383H18.6928C19.1718 4.17383 19.5602 4.56217 19.5602 5.04122V7.91473C19.5602 10.3432 17.5915 12.3118 15.1631 12.3118H4.79746C2.36902 12.3118 0.400391 10.3432 0.400391 7.91473V5.04122Z",
    fill: "#888888"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_2256_34316",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0918 2.17644C6.0918 1.52671 6.61851 1 7.26824 1H13.0471C13.6968 1 14.2236 1.52671 14.2236 2.17644V6.09205H6.0918V2.17644Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0918 2.17644C6.0918 1.52671 6.61851 1 7.26824 1H13.0471C13.6968 1 14.2236 1.52671 14.2236 2.17644V6.09205H6.0918V2.17644Z",
    stroke: "#888888",
    strokeWidth: 3.43521,
    mask: "url(#path-4-inside-1_2256_34316)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.53125 12.8813H11.539V13.2609C11.539 14.0915 10.8657 14.7648 10.0351 14.7648V14.7648C9.20455 14.7648 8.53125 14.0915 8.53125 13.2609V12.8813Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.a4b6e1abe679e6c11146749c0c5bcb5a.svg";
export { ForwardRef as ReactComponent };